export const PAGE_TITLE = "Advertising and Marketing";

export const PAGE_TEXT =
  "<b>The Institute of Interpersonal Hypnotherapy (IIH)</b> provides a variety of solutions to help graduates build and grow successful practices. We encourage students to start thinking about the business aspects of being a hypnotherapist early in their training. Take advantage of these valuable resources to ensure financial success:";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1Qn79W4eev81-z2ymGSg8wv6UCdBvohhi/preview";

export const SNACKBAR_SUCCESS_MESSAGE = "Data saved successfully";
